import { Plus } from "lucide-react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const faqs = [{
    question: "What is the minimum order quantity (MOQ)?",
    answer: "Our MOQ starts at just 50 pieces per style. This low entry point allows new brand founders to launch a professional collection and test market demand without the high financial risk of traditional manufacturing."
  }, {
    question: "Do I need to provide my own design files?",
    answer: "You don't need to be a designer. Simply provide your logo in a high-resolution format (AI, PDF, or PNG), and our team will create a professional digital mockup of your watch for approval before any production begins."
  }, {
    question: "How long does the production process take?",
    answer: "For our standard proven models with logo customization, production typically takes 2–4 weeks. Fully custom projects or complex modifications may require additional time, which we will confirm during the quoting stage."
  }, {
    question: "Can I order a sample before the full production run?",
    answer: "Sampling is optional to help you move faster. Many clients choose to go straight to production after approving their digital mockup to save time and costs, but physical samples can be arranged if your project requires it."
  }, {
    question: "What parts of the watch can I customize?",
    answer: "With our low MOQ service, you can customize the dial (logo placement), the caseback (engraving), the strap (material and branding), and the packaging to create a fully branded experience for your customers."
  }, {
    question: "How do I get a pricing quote for my project?",
    answer: "Pricing depends on the watch model, total quantity, and specific customization options. Contact us with your requirements, and we will provide a detailed, transparent quote within 24 hours."
  }, {
    question: "Do you ship internationally?",
    answer: "Yes, we ship to brand owners worldwide. Once production is complete and quality control is passed, international delivery typically takes 3–7 business days via reliable express couriers."
  }];
  return <section data-section-id="21212" id="faq-accordion" className="bg-muted py-24 px-6 md:px-12">
      <div ref={ref} className={`max-w-[800px] mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16">
          <h2 className="font-sans text-[32px] md:text-[32px] text-foreground mb-6 tracking-tight font-medium">
            Frequently Asked Questions
          </h2>
          <p className="font-sans text-secondary text-lg max-w-2xl mx-auto">Straight answers to the questions we hear most from new brand founders.</p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="bg-card border-b border-border last:border-0 px-4" data-index={i}>
              <AccordionTrigger className="group py-6 hover:no-underline [&>svg:last-child]:hidden">
                <span className="font-sans font-medium text-[18px] md:text-[18px] text-left text-foreground group-hover:text-primary pr-8 leading-snug transition-colors duration-200">
                  {faq.question}
                </span>
                <span className="shrink-0 text-muted-foreground transition-transform duration-300 group-data-[state=open]:rotate-45 group-data-[state=open]:text-primary ml-4">
                  <Plus className="size-6" />
                </span>
              </AccordionTrigger>
              <AccordionContent className="font-sans text-[16px] text-muted-foreground leading-[1.6] pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}